/**
 * notificationSound.js
 * Plays a soft notification chime using the Web Audio API.
 * No external file needed — generated programmatically.
 */

let _ctx = null;
function getCtx() {
  if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)();
  return _ctx;
}

/**
 * Play a two-tone notification chime.
 * Safe to call on every new inbound message — will no-op if AudioContext
 * is blocked (browsers require a user gesture first; subsequent calls work fine).
 */
export function playNotificationSound() {
  try {
    const ctx = getCtx();
    // Resume if suspended (e.g. browser auto-suspend after inactivity)
    if (ctx.state === 'suspended') ctx.resume();

    const now = ctx.currentTime;
    const gain = ctx.createGain();
    gain.connect(ctx.destination);
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.35, now + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.001, now + 0.6);

    // Two tones: 880 Hz → 1100 Hz
    const freqs = [880, 1100];
    freqs.forEach((freq, i) => {
      const osc = ctx.createOscillator();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, now + i * 0.15);
      osc.connect(gain);
      osc.start(now + i * 0.15);
      osc.stop(now + i * 0.15 + 0.25);
    });
  } catch (e) {
    // AudioContext unavailable or blocked — silently ignore
  }
}

/**
 * React hook: returns playSound() function.
 * Attaches a one-time click listener to unlock AudioContext on first interaction.
 */
export function useNotificationSound() {
  return playNotificationSound;
}
